import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import AgeVerificationBanner from './AgeVerificationBanner';
import './Layout.css';

const PAGINAS_CREADOR = [
  '/panel_creador', '/publica_anuncio', '/editar_publicacion',
  '/estado_publicaciones', '/estado_edicion', '/proceso_verificacion',
  '/estado_verificacion', '/saldo_ordencompra', '/agregar_saldo',
  '/gestion_avisos', '/publicacion_pausa', '/publicacion_renovar',
  '/cambio_contrasena_creador', '/PerfilContenido'
];

function Layout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const isPerfilPage = location.pathname.startsWith('/perfil/');
  const isPerfilContenidoPage = location.pathname.startsWith('/PerfilContenido/');
  const isVideoPrincipalPage = location.pathname === '/Video_principal';
  const esPaginaCreador = PAGINAS_CREADOR.includes(location.pathname);

  const shouldHideHeader = isHomePage || isPerfilPage || isPerfilContenidoPage || isVideoPrincipalPage;

  const [adminImpersonando, setAdminImpersonando] = useState(false);
  const [emailImpersonado, setEmailImpersonado] = useState('');

  useEffect(() => {
    if (!esPaginaCreador) return;
    fetch(`${process.env.REACT_APP_AUTH_CREADOR_URL}/check_session.php`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setAdminImpersonando(!!data.admin_impersonando);
          setEmailImpersonado(data.email || '');
        }
      })
      .catch(() => {});
  }, [esPaginaCreador]);

  const handleVolverAdmin = async () => {
    try {
      await fetch(`${process.env.REACT_APP_AUTH_ADMIN_URL}/detener_impersonacion.php`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (e) {
      console.error('Error al detener impersonacion:', e);
    }
    window.location.href = '/admin';
  };

  useEffect(() => {
    if (!adminImpersonando || !esPaginaCreador) return;

    let ultimaActividad = Date.now();
    const marcarActividad = () => { ultimaActividad = Date.now(); };

    const revisarInactividad = () => {
      const minutosInactivo = (Date.now() - ultimaActividad) / 60000;
      if (minutosInactivo >= 30) {
        handleVolverAdmin();
      }
    };

    const eventos = ['click', 'keydown', 'touchstart', 'mousemove'];
    eventos.forEach(ev => window.addEventListener(ev, marcarActividad));

    const alVolverALaPestana = () => {
      if (document.visibilityState === 'visible') {
        revisarInactividad();
      }
    };
    document.addEventListener('visibilitychange', alVolverALaPestana);

    const intervalo = setInterval(revisarInactividad, 60000);

    return () => {
      eventos.forEach(ev => window.removeEventListener(ev, marcarActividad));
      document.removeEventListener('visibilitychange', alVolverALaPestana);
      clearInterval(intervalo);
    };
  }, [adminImpersonando, esPaginaCreador]);

  const handleVolverPanelInicial = () => {
    navigate('/panel_creador');
  };

  const handleVolverPaginaAnterior = () => {
    if (window.history.length <= 2) {
      navigate('/panel_creador');
    } else {
      navigate(-1);
    }
  };

  const handleCerrarSesionCreador = async () => {
    try {
      await fetch(`${process.env.REACT_APP_AUTH_CREADOR_URL}/logout.php`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (e) {
      console.error('Error al cerrar sesion:', e);
    }
    window.location.href = '/acceso-publicar';
  };

  return (
    <div>
      {esPaginaCreador && (
        <div style={{
          position: 'sticky', top: 0, zIndex: 9998,
          background: '#3a0d09', padding: '8px 16px', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          flexWrap: 'wrap', gap: '10px'
        }}>
          <button onClick={handleVolverPanelInicial} style={{ background: '#f4a261', color: '#3b1a00', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-home"></i> Panel inicial
          </button>
          <button onClick={handleVolverPaginaAnterior} style={{ background: '#1e3a8a', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-arrow-left"></i> Pagina anterior
          </button>
          <button onClick={handleCerrarSesionCreador} style={{ background: '#dc143c', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-sign-out-alt"></i> Cerrar sesion
          </button>
        </div>
      )}
      {esPaginaCreador && adminImpersonando && (
        <div style={{
          position: 'sticky', top: 0, zIndex: 9999,
          background: '#ffcc00', color: '#3c2600',
          padding: '10px 20px', display: 'flex',
          alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: '8px', fontWeight: 'bold', fontSize: '14px'
        }}>
          <span>Estas viendo como: {emailImpersonado}</span>
          <button
            onClick={handleVolverAdmin}
            style={{ background: '#000', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' }}
          >
            Volver a admin
          </button>
        </div>
      )}
      <AgeVerificationBanner />
      {!shouldHideHeader && <Header />}
      
      {/* Barra adicional con el botón de publicar */}
      {!shouldHideHeader && (
        <div className="action-bar">
          <div className="action-bar-content">
            <Link to="/acceso-publicar" className="publish-button">
              <i className="fas fa-plus-circle"></i>
              Publica tu aviso - Registrate
            </Link>
          </div>
        </div>
      )}
      
      <main style={{ 
  display: 'block', 
  padding: isHomePage || isPerfilPage || isPerfilContenidoPage || isVideoPrincipalPage ? '0' : '20px' 
}}>
        {children}
      </main>

      {esPaginaCreador && location.pathname !== '/panel_creador' && (
        <div style={{
          background: '#3a0d09', padding: '8px 16px', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          flexWrap: 'wrap', gap: '10px'
        }}>
          <button onClick={handleVolverPanelInicial} style={{ background: '#f4a261', color: '#3b1a00', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-home"></i> Panel inicial
          </button>
          <button onClick={handleVolverPaginaAnterior} style={{ background: '#1e3a8a', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-arrow-left"></i> Pagina anterior
          </button>
          <button onClick={handleCerrarSesionCreador} style={{ background: '#dc143c', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-sign-out-alt"></i> Cerrar sesion
          </button>
        </div>
      )}
    </div>
  );
}

export default Layout;